import { render, staticRenderFns } from "./userRights.vue?vue&type=template&id=4a533838&scoped=true&"
import script from "./userRights.vue?vue&type=script&lang=js&"
export * from "./userRights.vue?vue&type=script&lang=js&"
import style0 from "./userRights.vue?vue&type=style&index=0&id=4a533838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a533838",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VForm,VTextField,VTextarea})
